export const defaultCountryCode = '91';

export const germanyCountryCode = '49';
